@if (copy) {
  <div class="tw-px-4 tw-pb-4 tw-overflow-visible tw-relative tw-font-body">
    <div class="tw-px-5 tw-py-4 tw-box-border tw-bg-white tw-rounded-xl tw-shadow-z3">
      @if (isHairFrontNotVisible) {
        <div [class]="titleSizeClass" class="tw-font-bold tw-mb-1" i18n="@@hairFrontNotVisible">Hair Front Not visible</div>
        <div [class]="descriptionSizeClass" class="tw-text-gray-700">
          <div class="tw-font-semibold tw-mb-1" i18n="@@hairFrontNotVisibleRetakePhoto">Retake photo by trying:</div>
          <ul class="tw-list-disc tw-list-inside tw-space-y-0.5">
            <li i18n="@@hairFrontNotVisibleHairline">Take clear picture showing front of hairline</li>
            <li i18n="@@hairFrontNotVisibleCamera">Clean your front camera / Use back camera</li>
            <li i18n="@@hairFrontNotVisibleLighting">Ensure good lighting</li>
          </ul>
        </div>
      } @else {
        <div [class]="titleSizeClass" class="tw-font-bold tw-mb-1">{{ copy.title }}</div>
        <div [class]="descriptionSizeClass" class="tw-text-gray-700">
          <div class="tw-font-semibold tw-mb-1">{{ copy.reasonsHeading }}</div>
          <ul class="tw-list-disc tw-list-inside tw-space-y-0.5">
            @for (reason of copy.reasons; track reason) {
              <li>{{ reason }}</li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
}
